import { render, staticRenderFns } from "./BillDetail.vue?vue&type=template&id=e356f65e&scoped=true&lang=pug&"
import script from "./BillDetail.vue?vue&type=script&lang=ts&"
export * from "./BillDetail.vue?vue&type=script&lang=ts&"
import style0 from "./BillDetail.vue?vue&type=style&index=0&id=e356f65e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e356f65e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
